<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
    <p>{{data.question}}</p>
</div>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="space-evenly center">
    <button mat-button [mat-dialog-close]="'option1'" cdkFocusInitial>{{data.option1}}</button>
    <button mat-button [mat-dialog-close]="'option2'">{{data.option2}}</button>
</div>